
import React, { useRef, useState } from 'react';
import './TranslateButton.css';

const GoogleTranslate = () => {
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const wrapperRef = useRef(null);

    const loadGoogleTranslateScript = () => {
        if (scriptLoaded) return;

        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: 'en',
                    layout: window.google.translate.TranslateElement.InlineLayout.VERTICAL,
                    autoDisplay: false,
                },
                'google_translate_element'
            );
        };

        const existingScript = document.getElementById('google-translate-script');
        if (!existingScript) {
            const script = document.createElement('script');
            script.id = 'google-translate-script';
            script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            script.async = true;
            document.body.appendChild(script);
        } else if (window.google && window.google.translate) {
            try {
                window.googleTranslateElementInit();
            } catch (err) {
                console.error('Failed to initialize Google Translate:', err);
            }
        }

        setScriptLoaded(true);
    };

    return (
        <div ref={wrapperRef} id="translate-wrapper" className="translate-wrapper">
            <button
                className="translate-toggle"
                onMouseEnter={loadGoogleTranslateScript}
                aria-label="Choose Language"
            >
                🌐 Choose Language
            </button>
            <div id="google_translate_element" className="translate-menu"></div>
        </div>
    );
};

export default GoogleTranslate;
